import { EmbeddedMotorVehicle, InsightVehicle } from "@shared/types"
import Moment from "moment"
import { unparse } from "papaparse"
import { generateFleetEntryStatus } from "./generateFleetEntryStatus"

export const downloadAsCsv = (data: unknown[], filename: string) => {
  const dataAsCsv = unparse(data, { header: true })
  const blob = new Blob([dataAsCsv], { type: `text/csv` })
  const a = document.createElement(`a`)
  a.download = filename
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent(`click`, {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

export const getCsvFileName = (filename: string, holder: string, policyNumber?: string) => {
  const date = Moment().format(`DD MMM YYYY`)
  return `${date} - ${holder} ${policyNumber ? `- ${policyNumber} ` : ``}- ${filename} - Flock.csv`
}

export const downloadFleetAsCsv = (
  fleet: ReadonlyArray<EmbeddedMotorVehicle>,
  holder: string,
  policyNumber?: string
) => {
  downloadAsCsv(
    fleet
      .filter(({ onCoverDate, offCoverDate }) => generateFleetEntryStatus(onCoverDate, offCoverDate) === `on_cover`)
      .map((vehicle) => ({
        "Vehicle Registration Number": vehicle.registrationNumber,
        "Vehicle Make": vehicle.vehicle.manufacturer,
        "Vehicle Model": vehicle.vehicle.model,
        "Vehicle On Cover Date": vehicle.onCoverDate,
        "Vehicle Off Cover Date": vehicle.offCoverDate,
      })),
    getCsvFileName(`Vehicle Schedule`, holder, policyNumber)
  )
}

export const downloadInsightVehiclesAsCsv = (
  fleet: ReadonlyArray<InsightVehicle>,
  holder: string,
  policyNumber: string
) => {
  downloadAsCsv(
    fleet.map((vehicle) => ({
      "Vehicle Registration Number": vehicle.vrn,
      Vehicle: vehicle.name,
      "Vehicle Score": vehicle.score,
      "Previous Period Vehicle Score Change": vehicle.scoreChange,
      "Miles Driven": vehicle.distance,
      "Miles Spent Speeding": vehicle.distanceSpentSpeedingPercentage,
      "Average Speed Exceedance": vehicle.averageSpeedExceedencePercentage,
    })),
    getCsvFileName(`Vehicle Insights`, holder, policyNumber)
  )
}
